import {
  createOptionalGuard,
  isNumber,
} from './internal';

export default createOptionalGuard<number>(isNumber);
